<template>
	<div id="newsCenter">
		<div class="topLan1">
			<img  @click="jumpToIndex" class="CoBrand" src="../../static/pic/logo_hudie0@2x.png" />
			<div class="lan">
				<router-link class="box1" :to="{path: 'index'}">首页</router-link>
				<router-link class="box1" :to="{name: 'platform'}">电商平台</router-link>
				<router-link class="box1" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link class="box1" :to="{name: 'about'}">关于我们</router-link>
				<router-link class="box1" :to="{name: 'newsCenter'}">新闻中心
					<div class="boxLine1"></div>
				</router-link>
				<router-link class="box1" :to="{name: 'recruit'}">人才招聘</router-link>
				<router-link class="box1" :to="{name: 'downLoad'}">下载APP</router-link>
				<!-- <a href="index" class="box1"></a>
				<a href="platform" class="box1">电商平台</a>
				<a href="canvass" class="box1">招商入驻</a>
				<a href="about" class="box1">关于我们</a>
				<a href="newsCenter" class="box1">新闻中心
					<div class="boxLine1"></div>
				</a>
				<a href="recruit" class="box1">人才招聘</a>
				<a href="downLoad" class="box1">下载APP</a> -->
			</div>
		</div>

		<div class="newsArea">
			<div class="newsSmallArea">
				<div class="newsBox" v-for="(item,index) in newsList" :key="index" @click="jump(item.id)">
					<div class="newstxtArea">
						<div class="newsDate">{{item.yearMonthDay}}</div>
						<div class="newsTitle">{{item.title}}</div>
						<div class="newsLine"></div>
						<!-- <div class="newsInfo">7月28日，重庆市副市长高圣华至蝴蝶调研工业互联网实施成果，市研究室主任吴建兴、市地
							方金融监管局副局长李新宇、张...</div> -->
						<div class="newsInfo">
							<p class="ql-editor newsInfoInside" v-html="item.introduction"></p>
						</div>
					</div>
					<img class="newsPic" :src="item.coverPic" />
				</div>

				<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getNewsList" />
			</div>
		</div>



		<bottom-area></bottom-area>
	</div>


</template>

<script>
	import {
		newsList
	} from "../../api/news.js"
	import bottomArea from "../components/bottomArea.vue"
	export default {
		components: {
			bottomArea
		},
		data() {
			return {
				list: [0, 1, 2, 3],
				queryParams: {
					pageNum: 1,
					pageSize: 10
				},
				newsList: [],
				total: 0
			}
		},
		created() {
			this.getNewsList()
			document.documentElement.scrollTop = 0
		},
		methods: {
			jump(id) {
				this.$router.push({
					name: 'newsDetail',
					params: {
						id: id
					}
				});
			},
			getNewsList() {
				newsList(this.queryParams).then(res => {
					this.newsList = res.data.rows
					this.total = res.data.total
				}).catch(err => {
					console.log(err)
				})
			},
			jumpToIndex(){
				this.$router.push({
					name: 'index',
					params: {}
				});
			}
		}
	}
</script>

<style scoped>
	html,
	body,
	#newsCenter {
		width: 100%;
		height: 100%;
		text-align: left;
	}

	.newsArea {
		width: 100%;
		margin-top: 228px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.newsSmallArea {
		width: 1230px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.newsBox {
		margin-bottom: 35px;
		width: 1220px;
		height: 252px;
		background: #FFFFFF;
		border-radius: 10px;
		box-shadow: 0px 0px 12px #F4F6F9;
		cursor: pointer;
	}

	.newstxtArea {
		float: left;
		margin-left: 58px;
		margin-top: 57px;
		width: 652px;
		height: 180px;
		display: flex;
		flex-direction: column;
		/* border: 1px solid #000000; */
	}

	.newsPic {
		float: right;
		margin-top: 30px;
		margin-right: 35px;
		width: 270px;
		height: 180px;
	}

	.newsDate {
		width: 100%;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
	}

	.newsTitle {
		margin-top: 10px;
		width: 100%;
		height: 24px;
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
		/* -webkit-box-orient: vertical; */
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/* autoprefixer: on */
		-webkit-line-clamp: 0;
		overflow: hidden;
	}

	.newsLine {
		margin-top: 28px;
		width: 30px;
		height: 2px;
		background: linear-gradient(90deg, #5E9EF7, #2D77E4);
	}

	.newsInfo {
		margin-top: 30px;
		width: 100%;
		height: 54px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #222222;
		line-height: 26px;
	}

	.el-pagination {
		margin-bottom: 100px;
		margin-top: 65px;
	}

	.newsInfoInside {
		display: -webkit-box;
		/* -webkit-box-orient: vertical; */
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/* autoprefixer: on */
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
</style>
